import React, { FunctionComponent } from 'react';
import { faUserFriends } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '..';

const BrassIconManager: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faUserFriends} />;

export { BrassIconManager };
